import { useEffect, useRef } from "react"
import { BaseAutocomplete, DropdownProps } from "components"

export function Dropdown<T, M extends boolean | undefined>({
	data,
	textFieldProps,
	onChange,
	value,
	multiple,
	getOptionLabel,
	isOptionEqualToValue,
	clearable = true,
	disabled,
	...autocompleteProps
}: DropdownProps<T, M>) {
	const hasFiredAutoSelect = useRef(false)

	const isSingleOption = !multiple && data.length === 1
	const singleDisabled = isSingleOption || disabled

	useEffect(() => {
		if (!isSingleOption || hasFiredAutoSelect.current) return
		const only = data[0]
		const alreadySelected = isOptionEqualToValue
			? value != null && isOptionEqualToValue(only as NonNullable<T>, value as NonNullable<T>)
			: value === only
		if (!alreadySelected) {
			hasFiredAutoSelect.current = true
			;(onChange as (val: T | null) => void)(only)
		}
	}, [isSingleOption, data, value, onChange, isOptionEqualToValue])

	useEffect(() => {
		if (!isSingleOption) hasFiredAutoSelect.current = false
	}, [isSingleOption])

	return (
		<BaseAutocomplete
			multiple={multiple}
			getOptionLabel={getOptionLabel}
			isOptionEqualToValue={isOptionEqualToValue}
			value={value}
			onChange={onChange}
			data={data}
			textFieldProps={textFieldProps}
			clearable={clearable}
			disabled={singleDisabled}
			{...autocompleteProps}
		/>
	)
}
